var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchbackReverseFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 487,
    height: 511,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 110.414v332.922c0 7.732 6.268 14 14 14h75.126c7.732 0 14-6.268 14-14V124.414c0-7.732 6.268-14 14-14h296.026c7.732 0 14-6.268 14-14V14c0-7.732-6.268-14-14-14H14C6.268 0 0 6.268 0 14v96.414z",
    fill: "#E3F5F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.397,
    y: 37,
    width: 430.604,
    height: 471,
    rx: 13,
    stroke: "#66C4AB",
    strokeWidth: 6
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDg3IiBoZWlnaHQ9IjUxMSIgdmlld0JveD0iMCAwIDQ4NyA1MTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wIDExMC40MTRWNDQzLjMzNkMwIDQ1MS4wNjggNi4yNjgwMSA0NTcuMzM2IDE0IDQ1Ny4zMzZIODkuMTI2NEM5Ni44NTg0IDQ1Ny4zMzYgMTAzLjEyNiA0NTEuMDY4IDEwMy4xMjYgNDQzLjMzNlYxMjQuNDE0QzEwMy4xMjYgMTE2LjY4MiAxMDkuMzk0IDExMC40MTQgMTE3LjEyNiAxMTAuNDE0SDQxMy4xNTJDNDIwLjg4NCAxMTAuNDE0IDQyNy4xNTIgMTA0LjE0NiA0MjcuMTUyIDk2LjQxMzdWMTRDNDI3LjE1MiA2LjI2OCA0MjAuODg0IDAgNDEzLjE1MiAwSDEwMy4xMjZIMTRDNi4yNjgwMSAwIDAgNi4yNjgwMSAwIDE0VjExMC40MTRaIiBmaWxsPSIjRTNGNUYxIi8+CjxyZWN0IHg9IjUzLjM5NjUiIHk9IjM3IiB3aWR0aD0iNDMwLjYwNCIgaGVpZ2h0PSI0NzEiIHJ4PSIxMyIgc3Ryb2tlPSIjNjZDNEFCIiBzdHJva2Utd2lkdGg9IjYiLz4KPC9zdmc+Cg==";
export { SvgSwitchbackReverseFrame as ReactComponent };